import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useTranslation } from "../../context/TranslationContext";
import { useNavigate } from "react-router-dom";
import List from "../../components/List";
import ListItem from "../../components/ListItem";

import '../../styles/Host.css'; 
import place from "../../resources/list/place.json"; 

function HostPlaces() {
  const { t } = useTranslation();
  const [state, setState] = useState("list");
  const [editItem, setEditItem] = useState({});
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/host'); 
  };

  const handleAdd = () => {
    setState("add");
  };

  const handleAddCancel = () => {
    setState("list");
  };

  const handleAddFinish = (item) => {
    setState("list");
  };

  const handleListClick = (item) => {
    setEditItem(item);
    setState("edit");
  };

  const getLabel = (item,viewLanguage) => {
    return item.name[viewLanguage] ? item.name[viewLanguage] : "";
  };

  const getDescription = (item,viewLanguage) => {
    var r = item.address.city ? item.address.city + " - " : "";
    if(item.slogan[viewLanguage]!==undefined) {
      r += item.slogan[viewLanguage];
    }
    return r
  };

  const contentMap = {
    list: (
      <List screens={place} title={t.host.Places} onBack={handleBack} onAdd={handleAdd} onClick={handleListClick} getLabel={getLabel} getDescription={getDescription}></List>
    ),
    add: (
      <ListItem mode="add" screens={place} startScreen="describe" onCancel={handleAddCancel} onFinish={handleAddFinish} finishLabel={t.general.Preview} getLabel={getLabel} getDescription={getDescription}></ListItem>
    ),
    edit: (
      <ListItem mode="edit" screens={place} startScreen="edit" editItem={editItem} onCancel={handleAddCancel} onFinish={handleAddFinish} finishLabel={t.general.Save} getLabel={getLabel} getDescription={getDescription}></ListItem>
    )
  };

  return (
    <>{(contentMap[state])}</>
  );
}

export default HostPlaces;